import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'
import { Container } from './Container'
import { SectionTitle } from './SectionTitle'
import { Button } from './Button'

const useStyles = makeStyles(() => ({
    section: { background: tokens.colorPrimaryLight, padding: '90px 0' },
    grid: {
        display: 'grid',
        gridTemplateColumns: '.9fr 1.1fr',
        gap: 60,
        alignItems: 'start',
        '@media (max-width: 1024px)': { gridTemplateColumns: '1fr' },
    },
    h2: {  display: 'flex', alignItems: 'flex-start' },
    p: { color: tokens.colorTextLight, marginBottom: 26 ,fontFamily: tokens.fontBody ,fontSize: '1rem'},
    details: { listStyle: 'none', margin: 0, padding: 0 ,marginBottom: 26},
    detailItem: {
        padding: '8px 0',
        borderTop: `1px solid ${tokens.colorBorder}`,
        fontSize: '.93rem',
        color: tokens.colorText,
        '&:last-child': { borderBottom: `1px solid ${tokens.colorBorder}` },
    },
    mapWrap: {
        minHeight: 450,
        borderRadius: tokens.radiusMd,
        overflow: 'hidden',
        '& iframe': { display: 'block' },
    },
   
}))

export function GetInTouch() {
    const classes = useStyles()
    return (
        <section className={classes.section} id="contact">
            <Container className={classes.grid}>
                <div>
                    <SectionTitle variant={'left'}>Get In Touch</SectionTitle>
                    <p className={classes.p}>
                        Have a testing challenge or a new project in mind? Send us the details
                        and our engineering team will get back to you within one business day.
                    </p>
                    <ul className={classes.details}>
                        <li className={classes.detailItem}><strong>Phone:</strong> +91 98980 42339</li>
                        <li className={classes.detailItem}><strong>Email:</strong> info@slscorp.com</li>
                        <li className={classes.detailItem}><strong>Address:</strong> Anand, Gujarat, India</li>
                    </ul> 
                    <Button href="/contact" variant="" className={classes.cta}>
                                            Get a Quote
                    </Button>
                 
                </div>

                <div className={classes.mapWrap}>
                    <iframe
                        title="SLS location map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4534.454889201841!2d72.9266366!3d22.536267!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e4dc33868317d%3A0x69485a5b140c602b!2sSystem%20Level%20Solutions!5e1!3m2!1sen!2sin!4v1784526650797!5m2!1sen!2sin"
                        width="600"
                        height="450"
                        style={{ border: 0, width: '100%' }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="strict-origin-when-cross-origin"
                    />
                </div>
                
            </Container>
        </section>
    )
}
